import './sponsors.scss';
import sponsorData from '../../sponsor-items/sponsors.json';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const sponsorTiers = sponsorData.tiers;

const hasValidLogo = (logo?: string) => typeof logo === 'string' && logo.trim().length > 0;
const sponsorAnchor = (name: string) => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const sponsorTarget = (tierName: string, sponsorName: string) =>
  `${sponsorAnchor(tierName)}-${sponsorAnchor(sponsorName)}`;

const Sponsors = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }

    const scrollToSponsor = () => {
      const sponsorCard = document.getElementById(hash.slice(1));
      const sponsorTier = sponsorCard?.closest<HTMLElement>('.sponsor-tier-section__tier');
      if (!sponsorTier) {
        return;
      }

      const navigationOffset = 85;
      const pageViewport = document.querySelector<HTMLElement>('.page-viewport');
      if (pageViewport) {
        const targetPosition = sponsorTier.getBoundingClientRect().top - pageViewport.getBoundingClientRect().top + pageViewport.scrollTop - navigationOffset;
        pageViewport.scrollTo({ top: Math.max(0, targetPosition), behavior: 'smooth' });
        return;
      }

      const targetPosition = sponsorTier.getBoundingClientRect().top + window.scrollY - navigationOffset;
      window.scrollTo({ top: Math.max(0, targetPosition), behavior: 'smooth' });
    };

    const frame = window.requestAnimationFrame(() => {
      window.requestAnimationFrame(scrollToSponsor);
    });

    return () => window.cancelAnimationFrame(frame);
  }, [hash]);

  return (
    <div className="sponsor-page">
    <section className="sponsor-hero">
      <div className="sponsor-hero__overlay" />
      <div className="sponsor-hero__content">
        <h1>Sponsors</h1>
        <p>Sponsorship opportunities</p>
      </div>
    </section>

    <section className="sponsor-tier-section">
      <div className="sponsor-tier-section__inner">
        <p className="sponsor-tier-section__heading">Our Supporters</p>

        <div className="sponsor-tier-section__stack">
          {sponsorTiers.map((tier) => (
            <article key={tier.name} className="sponsor-tier-section__tier">
              <div className="sponsor-tier-section__tier-header">
                <h2 className="sponsor-tier-section__title">{tier.name}</h2>
                <p className="sponsor-tier-section__description">{tier.description}</p>
              </div>

              <div className="sponsor-tier-section__sponsors">
                {tier.sponsors.map((sponsor) => (
                  <div
                    id={sponsorTarget(tier.name, sponsor.name)}
                    key={`${tier.name}-${sponsor.name}`}
                    className={`sponsor-tier-section__card${hash.slice(1) === sponsorTarget(tier.name, sponsor.name) ? ' sponsor-tier-section__card--highlighted' : ''}`}
                  >
                    <div className="sponsor-tier-section__logo-wrap">
                      {hasValidLogo(sponsor.logo) ? (
                        <img src={require(`../../sponsor-items/${sponsor.logo}`)} alt={sponsor.name} className="sponsor-tier-section__logo" />
                      ) : (
                        <div className="sponsor-tier-section__logo">Logo</div>
                      )}
                    </div>

                    <h3 className="sponsor-tier-section__sponsor-name">{sponsor.name}</h3>
                    <p className="sponsor-tier-section__sponsor-description">{sponsor.description}</p>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="sponsor-details">
      <div className="sponsor-details__inner">
        <div className="sponsor-details__section">
          <p className="sponsor-details__intro">
            If you would like to be a featured sponsor at one of our upcoming events,
            <br />
            please contact Liz Weber-Haynes at
            <br />
            <a href="mailto:eweberhaynes@atgovernmentstrategies.com">
              eweberhaynes@atgovernmentstrategies.com
            </a>
          </p>
        </div>
      </div>
    </section>
    </div>
  );
};

export default Sponsors;